import { Component, OnInit, ViewChild } from '@angular/core';
import { GeneralService } from '../services/general.service';
import { MatTableDataSource } from '@angular/material/table';
import { SelectionModel } from '@angular/cdk/collections';
import { ListeComponent } from "../liste/liste.component";
import { Router } from '@angular/router';
declare var $: any;
@Component({
  selector: 'app-caracteristique',
  templateUrl: './caracteristique.component.html',
  styleUrls: ['./caracteristique.component.scss']
})
export class CaracteristiqueComponent implements OnInit {

  constructor(private router: Router, private generalService: GeneralService) { }
  selection3 = new SelectionModel<any>(false, []);
  disabled = false;
  caracteristique = { ecArtCar_Id: "", ecArtCar_Label: "", ecArtCarMod_Id: "", ecArtCarMod_Filtre: 1 };
  initCarectiristique;
  dataSource = new MatTableDataSource([]);
  dataSourceAll;
  rowSelected = null;
  displayedColumns = ["ecArtCar_Id", "ecArtCar_Label", "ecArtCarMod_Filtre", "ecArtCarMod_Ordre"];
  listeCaracteristiqueModelAll;
  listeCaracteristiqueModel;
  categorieModelSelected;
  azerty: string = "";
  enregistrementTerminer = true;
  datasourceCarcarteristiqueValue = [];
  columnsCarcarteristiqueValue =
    {
      "TableRD":
        [
          {
            "TableRE_Code": "avtCRMActivity",
            "TableRD_Champs": "ecArtCarValList_Id",
            "Lg_Code": "ecArtCarValList_Id",
            "TableRD_Des": "Code",
            "TableRD_Largeur": 50,
            "TableRD_ReadOnly": true,
            "TableRD_Format": null,
            "TableRD_Alligement": 0,
            "TableRD_Ordre": 0,
            "TableRD_Type": 0,
            "TableRD_Param1": null,
            "TableRD_Param2": null,
            "TableRD_ValDef": null,
            "TableRD_Tri": true,
            "TableRD_Valid": null,
            "TableRD_ValidType": 0,
            "TableRD_ExpressionH": null,
            "TableRD_ExpressionR": null,
            "User_Id": "*",
            "User_Groupe": null
          },
          {
            "TableRE_Code": "avtCRMActivity",
            "TableRD_Champs": "ecArtCarValList_Label",
            "Lg_Code": "ecArtCarValList_Label",
            "TableRD_Des": "Label",
            "TableRD_Largeur": 200,
            "TableRD_ReadOnly": false,
            "TableRD_Format": null,
            "TableRD_Alligement": 0,
            "TableRD_Ordre": 1,
            "TableRD_Type": 0,
            "TableRD_Param1": null,
            "TableRD_Param2": null,
            "TableRD_ValDef": null,
            "TableRD_Tri": true,
            "TableRD_Valid": null,
            "TableRD_ValidType": 0,
            "TableRD_ExpressionH": null,
            "TableRD_ExpressionR": null,
            "User_Id": "*",
            "User_Groupe": null
          },
          {
            "TableRE_Code": "avtCRMActivity",
            "TableRD_Champs": "ecArtCarValList_Ordre",
            "Lg_Code": "ecArtCarValList_Ordre",
            "TableRD_Des": "Ordre",
            "TableRD_Largeur": 200,
            "TableRD_ReadOnly": false,
            "TableRD_Format": null,
            "TableRD_Alligement": 0,
            "TableRD_Ordre": 1,
            "TableRD_Type": 0,
            "TableRD_Param1": null,
            "TableRD_Param2": null,
            "TableRD_ValDef": null,
            "TableRD_Tri": true,
            "TableRD_Valid": null,
            "TableRD_ValidType": 0,
            "TableRD_ExpressionH": null,
            "TableRD_ExpressionR": null,
            "User_Id": "*",
            "User_Groupe": null
          }
        ]
    };
  onInput(event) {
    console.log(event.row);
    if (event.row.ecArtCarValList_Id) {
      this.generalService.getDS("ecArtCarValList", event.row.ecArtCarValList_Id).subscribe((data: any) => {
        console.log(data);
        data.ecArtCarValList[0].ecArtCarValList_Ordre = event.row.ecArtCarValList_Ordre
        this.generalService.enregisterTable(data).subscribe(res => {
          this.generalService.dialogSuccess("Enregistrer", true);
        }, error => {
          this.generalService.dialogSuccess("Non enregistrer", false)

        })
      })
    }
  }
  listBtnCarcarteristiqueValue: Array<any> = [{ name: "supprimerValue", class: "colorRed", text: "Supprimer", disabled: false }];
  caracteristiqueValue;
  initValeurCaracteristique;
  disabledBtnSupprimer: boolean = false;
  @ViewChild(ListeComponent) listeComponent: ListeComponent;
  ngOnInit() {
    if (this.generalService.userConnecter == "") {
      this.router.navigate([""]);
    }
    else {
      this.caracteristiqueValue = {};
      this.getInitCaracreristique();
      this.getListeCaracreristique();
      this.getListeCaracteristiqueModel();
      this.getInitValeurCaracteristique();
    }

  }
  getInitValeurCaracteristique() {
    this.generalService.rechercheTable(this.generalService.urlValeurCaracteristique).subscribe(data => {
      this.initValeurCaracteristique = data;
      this.caracteristiqueValue = data.ecArtCarValList[0];
    })
  }
  getListeCaracteristiqueModel() {
    this.generalService.rechercheTable(this.generalService.urlListeModel).subscribe(data => {
      this.listeCaracteristiqueModelAll = data
      this.listeCaracteristiqueModel = this.generalService.clone(data);
    })
  }
  getListeCaracreristique() {
    this.generalService.rechercheTable(this.generalService.urlListeCaracteristique).subscribe(data => {
      this.dataSourceAll = data;

      //this.dataSource =new MatTableDataSource(this.generalService.clone(data)); 
      this.setDataSource();
    })
  }
  getInitCaracreristique() {
    this.generalService.rechercheTable(this.generalService.urlCarectiristique).subscribe(data => {
      this.initCarectiristique = data;
    })
  }
  ajouter(f) {
    if (f.form.valid) {
      var testExist = this.dataSource.data.find(cat => { return cat.ecArtCar_Label == this.caracteristique.ecArtCar_Label })
      if (testExist == undefined) {
        this.enregistrementTerminer = false;
        this.initCarectiristique.ecArtCar[0].ecArtCarMod_Id = this.generalService.clone(this.caracteristique.ecArtCarMod_Id);
        this.initCarectiristique.ecArtCar[0].ecArtCar_Label = this.generalService.clone(this.caracteristique.ecArtCar_Label);
        var filter = 0;
        if (this.caracteristique.ecArtCarMod_Filtre)
          filter = 1
        this.initCarectiristique.ecArtCar[0].ecArtCarMod_Filtre = filter;
        //this.initCarectiristique.ecArtCar[0].ecArtCar_Id = this.generalService.clone( this.caracteristique.ecArtCar_Id);
        this.updateDB(this.initCarectiristique);
        var row = this.generalService.clone({ ecArtCar_Id: this.caracteristique.ecArtCar_Id, ecArtCar_Label: this.caracteristique.ecArtCar_Label });
        this.dataSource.data.push(row);
        if (this.dataSource.data.length > 5) {
          $("#tablecaracteristiques").addClass("tableClass")
        }
        else {
          $("#tableCaracteristiques").removeClass("tableClass")
        }
        this.dataSource = new MatTableDataSource(this.dataSource.data);
      }
      else
        this.generalService.dialogSuccess("Veuillez saisir un nouveau caractéristique", false);
    }
  }
  ajouterCaracteristiqueValue(form) {
    if (form.form.valid && this.rowSelected != null) {
      this.initValeurCaracteristique.ecArtCarValList[0].ecArtCar_Id = this.rowSelected.ecArtCar_Id;
      this.generalService.enregisterTable(this.initValeurCaracteristique).subscribe(data => {
        this.showValueCaracteristique();
        this.generalService.dialogSuccess("Enregistrer", true);
      },
        (err) => {
          this.generalService.dialogSuccess("Non enregistrer", false);
        })
    }
    else
      this.generalService.dialogSuccess("Veuillez sélectionner une caractéristique et saisir une désignation", false)

  }
  updateDB(ds) {
    console.log(ds);
    this.generalService.enregisterTable(ds).subscribe(data => {
      this.enregistrementTerminer = true;
      this.generalService.dialogSuccess("Caractéristique enregister", true);
      this.getListeCaracreristique();
    },
      (err) => {
        this.generalService.dialogSuccess("Caractéristique non enregisté", false);
      });
  }
  selectRow(event, row) {
    var els = document.getElementsByClassName("mat-row");
    Array.prototype.forEach.call(els, function (el) {
      el.style = "";
    });
    event.currentTarget.style = "background-color: #a0bdf3;";
    this.rowSelected = row;
    this.showValueCaracteristique();
  }
  showValueCaracteristique() {
    if (this.rowSelected != undefined)
      this.generalService.rechercheTable(this.generalService.urllisteValeurCaracteristique + this.rowSelected.ecArtCar_Id).subscribe(data => {
        this.listeComponent.setDataSource(data)
      })
  }
  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
  modifier(rowSelected) {
    if (rowSelected != null) {
      var url = this.generalService.urlCarectiristique + "&val=" + rowSelected.ecArtCar_Id;
      this.enregistrementTerminer = false;
      this.generalService.rechercheTable(url).subscribe(data => {
        data.ecArtCar[0].ecArtCar_Label = rowSelected.ecArtCar_Label;
        data.ecArtCar[0].ecArtCarMod_Ordre = rowSelected.ecArtCarMod_Ordre;
        var filter = 0;
        if (rowSelected.ecArtCarMod_Filtre)
          filter = 1
        data.ecArtCar[0].ecArtCarMod_Filtre = filter;
        this.updateDB(data);
      },
        (err) => {
        });
    }
    else
      this.generalService.dialogSuccess("Veuiller selectionner une ligne", false);


  }
  supprimer() {
    if (this.rowSelected != undefined) {
      var deleteFn = this.generalService.supprimer(this.rowSelected.ecArtCar_Id, "ecartcar");
      if (deleteFn != null) {
        this.enregistrementTerminer = false;
        this.listBtnCarcarteristiqueValue[0].disabled = true
        deleteFn.subscribe(data => {
          this.getListeCaracreristique();
          this.generalService.dialogSuccess("Elément supprimer", true);
          this.enregistrementTerminer = true;
          this.listBtnCarcarteristiqueValue[0].disabled = false;
        },
          error => {
            this.generalService.dialogSuccess("Elément non supprimé", false);
            this.enregistrementTerminer = true;
            this.listBtnCarcarteristiqueValue[0].disabled = false;
          });
      }
    }
  }
  onCaracteristiqueModelValuechange(e) {
    var myList = this.listeCaracteristiqueModelAll;
    var list = myList.filter((val) => {
      return val.ecArtCarMod_Label.toLowerCase().indexOf(e.target.value.toLowerCase()) >= 0;
    });
    if (list.length == 0) {
      list = myList;
      e.target.value = e.target.value.substr(0, (e.target.value.length - 1));
    }
    if (list.length == 1) {
      this.caracteristiqueModelSelected({ option: { value: { ecArtCarMod_Id: list[0].ecArtCarMod_Id } } });
    }
    this.listeCaracteristiqueModel = list;
  }
  caracteristiqueModelSelected(event) {

    this.categorieModelSelected = this.listeCaracteristiqueModelAll.find(cat => { return cat.ecArtCarMod_Id == event.option.value.ecArtCarMod_Id });
    this.caracteristique.ecArtCarMod_Id = this.categorieModelSelected.ecArtCarMod_Id;
    this.setDataSource();
  }
  setDataSource() {
    if (this.categorieModelSelected != undefined) {
      var data = this.dataSourceAll.filter(data => {
        return data.ecArtCarMod_Id == this.categorieModelSelected.ecArtCarMod_Id;
      });
      this.dataSource = new MatTableDataSource(data);
    }

  }
  setTextInput(cat) {
    if (cat) {
      return cat.ecArtCarMod_Label
    }
  }
  clickBtnHeat(event) {
    switch (event.name) {
      case "modifierValue":
        {
          alert(event.name)
          break;
        }
      case "supprimerValue":
        {
          this.supprimerValeurCaracteristique(event.row)
          break;
        }
      case "selectRow":
        {
          break;
        }
      case "ecArtCarValList_Label":
        {
          this.saveCaracteristiqueValue(event.row);
          break;
        }
      case "ecArtCarValList_Ordre":
        {
          this.saveCaracteristiqueValue(event.row);
          break;
        }
    }
  }
  supprimerValeurCaracteristique(row) {
    if (this.rowSelected != undefined) {
      var deleteFn = this.generalService.supprimer(row.ecArtCarValList_Id, "ecArtCarValList");
      if (deleteFn != null) {
        this.enregistrementTerminer = false;
        this.disabledBtnSupprimer = true
        deleteFn.subscribe(data => {
          this.showValueCaracteristique();
          this.generalService.dialogSuccess("Elément supprimer", true);
          this.enregistrementTerminer = true;
          this.disabledBtnSupprimer = false;
        },
          error => {
            this.generalService.dialogSuccess("Elément non supprimé", false);
            this.enregistrementTerminer = true;
            this.disabledBtnSupprimer = false;
          });
      }
    }
  }
  saveCaracteristiqueValue(row) {
    this.generalService.rechercheTable(this.generalService.urlValeurCaracteristique + "&val=" + row.ecArtCarValList_Id).subscribe(data => {
      data.ecArtCarValList[0].ecArtCarValList_Label = row.ecArtCarValList_Label;
      data.ecArtCarValList[0].ecArtCarValList_Ordre = row.ecArtCarValList_Ordre;
      this.generalService.enregisterTable(data).subscribe(d => {
        this.generalService.dialogSuccess("Enregistrer", true)
      })
    });
  }
}
